import React, { ComponentProps, FC } from 'react';

import { PlayToggle } from '../../skin/play-toggle/component';
import { useToggleOnAirWithIndicator } from '../../../hooks/skin/use-toggle-on-air-with-indicator';

export const LivePlayToggle: FC<Omit<ComponentProps<typeof PlayToggle>, 'onClick'>> = (props) => {
    const { toggleOnAir } = useToggleOnAirWithIndicator();

    return <PlayToggle onClick={toggleOnAir} {...props} />;
};
